import UnreadNotificationsIndicator from './UnreadNotificationsIndicator';

export default UnreadNotificationsIndicator;
